import { Person } from '@mui/icons-material';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { AuthRole } from '@libs/types';
import { routes } from '@carcareers/utils';
import { useAuth } from '@carcareers/hooks';

export const AccountProfileMenuItem = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user || user.role !== AuthRole.JOBSEEKER) {
    return null;
  }

  return (
    <MenuItem onClick={() => navigate(`/${routes.JOBSEEKER_HOME}`)}>
      <ListItemIcon>
        <Person />
      </ListItemIcon>
      <ListItemText>View Profile</ListItemText>
    </MenuItem>
  );
};
